import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            simpleMap: "getSimpleMap",
            simpleMaps: "getSimpleMaps",
            selectedMarker: "getMarker",
        }),
    },
    methods: {
        openWin: function(content, leftOffset, topOffset) {
            if(typeof this.curOpenWin !== 'undefined') {
                this.curOpenWin.hide();
            }

            var $layerPopupDiv = $("#layer-popup-div");

            // 창크기 초기화
            $layerPopupDiv.css({
                position: 'absolute',
                left: '',
                width: '',
                height: ''
            });

            $layerPopupDiv.html(content);

            var width = $layerPopupDiv.width();
            var height = $layerPopupDiv.height();

            if(typeof leftOffset === 'undefined') {
                leftOffset = 0.08;
            }

            if(typeof topOffset === 'undefined') {
                topOffset = 1.07;
            }

            var left = this.selectedMarker.eventX - (width * leftOffset);
            var top = this.selectedMarker.eventY - (height * topOffset);

            $layerPopupDiv.css({
                position: 'absolute',
                left: left,
                top: top,
                width: width,
                height: height
            });

            $("#layer-popup-div a.self-close-btn").on('click', function(event) {
                $layerPopupDiv.hide();
//                this.$store.dispatch('FETCH_CUR_OPEN_WIN', undefined);
            }.bind(this));

            $layerPopupDiv.show();
//            this.$store.dispatch('FETCH_CUR_OPEN_WIN', $layerPopupDiv);
        },

        openWinAt: function(content, leftOffset, topOffset, left, top) {
            if(typeof this.curOpenWin !== 'undefined') {
                this.curOpenWin.hide();
            }

            var $layerPopupDiv = $("#layer-popup-div");

            // 창크기 초기화
            $layerPopupDiv.css({
                position: 'absolute',
                width: '',
                height: ''
            });

            $layerPopupDiv.html(content);

            var width = $layerPopupDiv.width();
            var height = $layerPopupDiv.height();

            if(typeof leftOffset === 'undefined') {
                leftOffset = 0.08;
            }

            if(typeof topOffset === 'undefined') {
                topOffset = 1.07;
            }

            left = left - (width * leftOffset);
            top = top - (height * topOffset);

            $layerPopupDiv.css({
                position: 'absolute',
                left: left,
                top: top,
                width: width,
                height: height
            });

            $("#layer-popup-div a.self-close-btn").on('click', function(event) {
                $layerPopupDiv.hide();
                this.$store.dispatch('FETCH_CUR_OPEN_WIN', undefined);
            }.bind(this));

            $layerPopupDiv.show();

            this.$store.dispatch('FETCH_CUR_OPEN_WIN', $layerPopupDiv);
        },

        loadedInfoHandle: function(content) {
            if(typeof this.selectedMarker !== 'undefined') {
                var winHeight = window.innerHeight;
                var eventY = this.selectedMarker.eventY;

                if(eventY >= (winHeight / 2)) {
                    this.openWin(content, 0, 1);
                } else {
                    this.openWin(content, 0, 0);
                }
            }
        },

        closeWin: function() {
            var $layerPopupDiv = $("#layer-popup-div");
            $layerPopupDiv.hide();
        },
    },
};
